import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  EDIT_ABONNEMENT,
  LIST_FORFAIT,
  LISTE_COMMUNE_SANS_PAGINATION,
} from "../../Utils/constant";
import doc from "../../assets/images/demande.png";
import { updateOne } from "../../services/service";
import { useStoreBatiment } from "../../store/Paramettre/batimentStore";
import { useStoreEquipement } from "../../store/Paramettre/equipementStore";
import { useIntentionStore } from "../../store/intentionStore";
import { useStoreApp } from "../../store/storeApp";
import { useStoreCommune } from "../../store/storeCommune";
import CommuneAutocomplete from "../Widget/CommuneAutoComplete";
import { SubmitButton } from "../Widget/SubmitButton";

export const UpdateDemandeIntention = ({ item, setMessage }) => {
  const listeCommune = useStoreCommune();
  const [communeId, setCommuneId] = useState(item?.communeId);

  // Préremplissage des valeurs par défaut
  const defaultValues = {
    nomPrenoms: item?.client?.nomPrenoms || "",
    email: item?.client?.email || "",
    contatct: item?.client?.numero || "",
    secondContact: item?.client?.secondNumero || "",
    numeroAvantage: item?.numeroMtn || "",
    typeClient: item?.typeClient || "",
    equipementId: item?.equipementId || "",
    forfaitId: item?.forfaitId || "",
    batimentId: item?.batimentId || "",
    quartier: item?.quartier || "",
    commune: item?.commune || "",
  };

  const {
    register,
    unregister,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ defaultValues });
  const [isSubmit, setIsSubmit] = useState(false);

  const forfaits = useStoreApp();
  const batiments = useStoreBatiment();
  const typeEquipements = useStoreEquipement();

  // Synchronise les valeurs par défaut si item change
  useEffect(() => {
    if (item) {
      reset({
        nomPrenoms: item?.client?.nomPrenoms || "",
        email: item?.client?.email || "",
        contatct: item?.client?.numero || "",
        secondContact: item?.client?.secondNumero || "",
        numeroAvantage: item?.numeroMtn || "",
        typeClient: item?.typeClient || "",
        equipementId: item?.equipementId || "",
        forfaitId: item?.forfaitId || "",
        batimentId: item?.batimentId || "",
        quartier: item?.quartier || "",
        commune: item?.commune || "",
      });
      setCommuneId(item?.communeId || null);
    }
  }, [item, reset]);

  useEffect(() => {
    forfaits.getData(LIST_FORFAIT, { page: 0, param: "", size: 10 }, "");
    typeEquipements.equipement({ page: 0, param: "", size: 10 });
    batiments.batiments({ page: 0, param: "", size: 10 });
    listeCommune.getData(`${LISTE_COMMUNE_SANS_PAGINATION}?prestataireId=`);

    if (item.statusConfirmation === "CONFIRMER") {
      unregister("equipementId");
      unregister("forfaitId");
      unregister("batimentId");
      unregister("statusConfirmation");
    }
  }, [item]);
  const intentions = useIntentionStore();

  const submit = (data) => {
    setIsSubmit(true);
    updateOne(EDIT_ABONNEMENT, item.id, {
      ...data,
      communeId: communeId,
    })
      .then((res) => {
        if (res.status === 200) {
          setIsSubmit(null);
          reset();
          intentions.intentionList(
            { page: 0, param: ``, size: 8 },
            `&statusSuppression=&status=&date=&isActive=&sousMenu=`,
          );
          toast.success("Intention modifié");
          console.log(res);
          localStorage.setItem(
            "numeroTicket",
            res?.data?.eligibilite?.numeroTicket,
          );
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        setMessage(err?.response?.data?.donnee);
        // toast.error(err?.response?.data?.donnee);
      });
  };

  return (
    <>
      {isSubmit === null ? (
        <div className="flex justify-center my-28 w-full">
          <div className="text-center">
            <img className="mx-auto" src={doc} height={80} width={80} alt="" />
            <p className="font-light mt-2  text-sm">
              Intention d'abonnement modifiée
            </p>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit(submit)} className="w-full  mx-auto mt-6">
          <div className="my-3">
            <h2 className=" font-medium">Client</h2>
            <hr />
          </div>

          <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
            <label className="form-control grid lg:grid-cols-2 md:grid-cols-2 xl:grid-cols-2 grid-cols-1 gap-2  w-full">
              <div>
                Nom et prenom <span className="text-red-500">*</span>
                <input
                  {...register("nomPrenoms")}
                  type="text"
                  placeholder="Nom & prénoms "
                  className="input input-bordered w-full h-10 text-sm "
                />
              </div>
              <div>
                Email <span className="text-red-500">*</span>
                <input
                  {...register("email")}
                  type="text"
                  placeholder="Email"
                  className="input input-bordered w-full h-10 text-sm "
                />
              </div>

              <div>
                Contact <span className="text-red-500">*</span>
                <input
                  {...register("contatct")}
                  type="text"
                  placeholder="Contact client"
                  className="input input-bordered w-full h-10 text-sm "
                />
              </div>

              <div>
                Second contact <span className="text-red-500">*</span>
                <input
                  {...register("secondContact")}
                  type="text"
                  placeholder="Second contact client"
                  className="input input-bordered w-full h-10 text-sm "
                />
              </div>
              <div>
                Numero avantages <span className="text-red-500">*</span>
                <input
                  type="text"
                  {...register("numeroAvantage")}
                  placeholder="Numero pour les avantages"
                  className="input input-bordered w-full h-10 text-sm "
                />
              </div>

              <div>
                Type client <span className="text-red-500">*</span>
                <select
                  {...register("typeClient", { required: true })}
                  className="select select-bordered w-full h-10"
                >
                  <option disabled value="">
                    type de client
                  </option>
                  <option value="PARTICULIER">Particulier</option>
                  <option value="ENTREPRISE">Entreprise</option>
                </select>
              </div>

              {item?.statusConfirmation === "CONFIRMER" ? null : (
                <>
                  <div>
                    Type equipement <span className="text-red-500">*</span>
                    <select
                      {...register("equipementId")}
                      className="select select-bordered w-full h-10"
                    >
                      <option disabled value="">
                        type d'équipement
                      </option>
                      {typeEquipements?.data?.equipements?.map((equip) => (
                        <option key={equip.id} value={equip.id}>
                          {equip.designation}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    Choisir un forfait <span className="text-red-500">*</span>
                    <select
                      {...register("forfaitId")}
                      className="select select-bordered w-full h-10"
                    >
                      <option disabled value="">
                        Choisir un forfait
                      </option>
                      {forfaits?.data?.data?.map((forfait) => (
                        <option key={forfait.id} value={forfait.id}>
                          {forfait.designation}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    Type batiment <span className="text-red-500">*</span>
                    <select
                      {...register("batimentId")}
                      className="select select-bordered w-full h-10"
                    >
                      <option disabled value="">
                        type de batiment
                      </option>
                      {batiments?.data?.batiments?.map((bat) => (
                        <option key={bat.id} value={bat.id}>
                          {bat.designation}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}
            </label>
          </div>
          <CommuneAutocomplete
            setValue={setCommuneId}
            listeCommune={listeCommune}
            defaultValue={item?.commune}
          />

          <div>
            <label className="text-sm">Quartier</label>
            <input
              {...register("quartier")}
              type="text"
              placeholder="quartier du client"
              className="input input-bordered w-full h-10 text-sm "
            />
          </div>

          {isSubmit === null ? null : (
            <SubmitButton isSubmit={isSubmit} label={"Modifier l'intention"} />
          )}
        </form>
      )}
    </>
  );
};
